import {GLModel} from "./GLModel";
import {Camera} from "./Camera";
import {Matrix} from "./Matrix";
import {Polygon} from "./Polygon";

export class GLInstancedObject {
    instancePositions:Array<number>;
    instanceRotations:Array<number>;
    positionsBuffer;
    rotationsBuffer;
    instanceCount:number;
    shader:WebGLProgram;
    model:GLModel;
    uniforms:Array<{name:string,val:any}>;
    constructor(shader:WebGLProgram,model:GLModel,gl:WebGLRenderingContext,count:number) {
        this.instancePositions = new Array<number>();
        this.instanceRotations = new Array<number>();
        this.instanceCount = count;
        this.shader = shader;
        this.model = model;
        this.uniforms = [];
        for(let i = 0; i < count; i++){
            this.instancePositions.push(0);
            this.instancePositions.push(0);
            this.instancePositions.push(0);

            this.instanceRotations.push(0);
            this.instanceRotations.push(0);
            this.instanceRotations.push(0);
        }

        this.positionsBuffer = Polygon.CreateVBO(this.instancePositions,gl);
        this.rotationsBuffer = Polygon.CreateVBO(this.instanceRotations,gl);

    }
    Translate(amount:Array<number>,index:number){
        this.instancePositions[index * 3] += amount[0];
        this.instancePositions[index * 3 + 1] += amount[1];
        this.instancePositions[index * 3 + 2] += amount[2];
    }
    Rotate(amount:Array<number>,index:number){
        this.instanceRotations[index * 3] += amount[0];
        this.instanceRotations[index * 3 + 1] += amount[1];
        this.instanceRotations[index * 3 + 2] += amount[2];

    }

    UpdateBuffer(gl:WebGLRenderingContext){
        gl.bindBuffer(gl.ARRAY_BUFFER,this.positionsBuffer);
        gl.bufferSubData(gl.ARRAY_BUFFER,0,new Float32Array(this.instancePositions));
        gl.bindBuffer(gl.ARRAY_BUFFER,null);
        gl.bindBuffer(gl.ARRAY_BUFFER,this.rotationsBuffer);
        gl.bufferSubData(gl.ARRAY_BUFFER,0,new Float32Array(this.instanceRotations));
        gl.bindBuffer(gl.ARRAY_BUFFER,null);
    }

    Draw = (camera:Camera,gl:WebGLRenderingContext,ext:ANGLE_instanced_arrays) => {
        const M = Matrix.identity(Matrix.create());
        const V = camera.V;
        const P = camera.P;
        gl.useProgram(this.shader);

        const positionAttLocation = gl.getAttribLocation(this.shader, 'position');
        gl.bindBuffer(gl.ARRAY_BUFFER, this.model.vbo);
        gl.enableVertexAttribArray(positionAttLocation);
        gl.vertexAttribPointer(positionAttLocation, 3, gl.FLOAT, false, 0, 0);
        ext.vertexAttribDivisorANGLE(positionAttLocation, 0);

        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.model.ibo);
        let MVPUniLocation = gl.getUniformLocation(this.shader, 'mvpMatrix');
        gl.uniformMatrix4fv(MVPUniLocation, false, Matrix.GenerateMVP(M,V,P));

        for(let i = 0; i < this.uniforms.length;i++){
            let uniLocation = gl.getUniformLocation(this.shader, this.uniforms[i].name);
            gl.uniform3fv(uniLocation, new Float32Array(this.uniforms[i].val));
        }


        const instancePosAttLocation = gl.getAttribLocation(this.shader, 'instancePos');
        gl.bindBuffer(gl.ARRAY_BUFFER, this.positionsBuffer);
        gl.enableVertexAttribArray(instancePosAttLocation);
        gl.vertexAttribPointer(instancePosAttLocation, 3, gl.FLOAT, false, 0, 0);
        ext.vertexAttribDivisorANGLE(instancePosAttLocation, 1);

        const instanceRotAttLocation = gl.getAttribLocation(this.shader, 'instanceRot');
        gl.bindBuffer(gl.ARRAY_BUFFER, this.rotationsBuffer);
        gl.enableVertexAttribArray(instanceRotAttLocation);
        gl.vertexAttribPointer(instanceRotAttLocation, 3, gl.FLOAT, false, 0, 0);
        ext.vertexAttribDivisorANGLE(instanceRotAttLocation, 1);

        gl.drawElements(gl.TRIANGLES, this.model.indexCount,gl.UNSIGNED_SHORT, 0);
        ext.drawElementsInstancedANGLE(gl.TRIANGLES, this.model.indexCount, gl.UNSIGNED_SHORT, 0, this.instanceCount);

    }
}